<template>
  <button
    :class="[containerClasses, containerSizeClasses]"
    class="outline-none font-body flex items-center border border-solid rounded-full select-none pills-BasePill group w-fit bg-whiteOverride"
    data-test="container">
    <div
      v-if="withCircle"
      :class="[circleClasses, circleSizeClasses]"
      class="flex items-center justify-center rounded-full ml-2"
      data-test="circle">
      <svg
        :class="[svgSizeClasses, svgClasses]"
        viewBox="0 0 200 200"
        data-test="svg">
        <path
          :class="{ 'visible group-focus-visible:invisible lg:group-hover:invisible' : selected, 'group-focus-visible:visible lg:group-hover:visible' : hoverable }"
          data-test="tick"
          d="M22.1739 87.8261L3.04346 106.957L68.6956 172.609L195.652 45.6522L176.522 26.5217L68.6956 134.348L22.1739 87.8261Z"
        /><!--TODO remove 'lg:' on line 18 after upgrading to Tailwind V3 - can replace with hoverOnlyWhenSupported-->
        <path
          v-if="selected"
          class="invisible lg:group-hover:visible group-focus-visible:visible"
          data-test="cross"
          d="M14 162.651L33.2063 181.857L100.429 114.635L167.651 181.857L186.857 162.651L119.635 95.4285L186.857 28.2064L167.651 9.00001L100.429 76.2222L33.2063 9.00001L14 28.2064L81.2222 95.4285L14 162.651Z"
        /><!--TODO remove 'lg:' on line 24 after upgrading to Tailwind V3 - can replace with hoverOnlyWhenSupported-->
      </svg>

    </div>
    <div
      :class="[textClasses, textSizeClasses]"
      class="font-normal whitespace-nowrap"
      data-test="text">
      {{ text }}
    </div>
  </button>
</template>

<script>
const sizes = [
  'normal',
  'large',
];
const defaultTheme = {
  defaultContainerClasses: 'border-{#E5E5E5}',
  defaultCircleClasses: 'bg-black',
  defaultTextClasses: 'text-dark',
  defaultSvgClasses: 'fill-none',
  hoverContainerClasses: 'hover:bg-black',
  hoverCircleClasses: 'lg:group-hover:bg-whiteOverride group-focus-visible:bg-whiteOverride', // TODO remove 'lg:' after upgrading to Tailwind V3 - can replace with hoverOnlyWhenSupported
  hoverTextClasses: 'lg:group-hover:text-whiteOverride group-focus-visible:text-whiteOverride', // TODO remove 'lg:' after upgrading to Tailwind V3 - can replace with hoverOnlyWhenSupported
  hoverSvgClasses: 'fill-none lg:group-hover:fill-white group-focus-visible:fill-white', // TODO remove 'lg:' after upgrading to Tailwind V3 - can replace with hoverOnlyWhenSupported
  selectedContainerClasses: 'bg-black',
  selectedCircleClasses: 'bg-whiteOverride',
  selectedTextClasses: 'text-whiteOverride',
  selectedSvgClasses: 'fill-black',
};

export default {
  name: 'BasePill',
  props: {
    text: {
      type: String,
      required: true,
    },
    withCircle: {
      type: Boolean,
      required: false,
      default: true,
    },
    hoverable: {
      type: Boolean,
      required: false,
      default: false,
    },
    selected: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      required: false,
      default: 'normal',
      validator(value) {
        return sizes.includes(value);
      },
    },
    theme: {
      type: Object,
      required: false,
      default: () => defaultTheme,
      // TODO: validate theme
    },
  },
  computed: {
    themeClasses() {
      return {
        ...defaultTheme,
        ...this.theme,
      };
    },
    containerClasses() {
      return {
        [this.themeClasses.defaultContainerClasses]: !this.selected,
        [this.themeClasses.hoverContainerClasses]: this.hoverable && !this.selected,
        [this.themeClasses.selectedContainerClasses]: this.selected,
        'cursor-pointer': this.hoverable,
      };
    },
    containerSizeClasses() {
      return {
        normal: 'size-normal p-{5px}',
        large: 'size-large p-{8px}',
      }[this.size];
    },
    circleClasses() {
      return {
        [this.themeClasses.defaultCircleClasses]: !this.selected,
        [this.themeClasses.hoverCircleClasses]: this.hoverable && !this.selected,
        [this.themeClasses.selectedCircleClasses]: this.selected,
      };
    },
    circleSizeClasses() {
      return {
        normal: 'w-base h-base',
        large: 'w-{25px} h-{25px}',
      }[this.size];
    },
    svgSizeClasses() {
      return {
        normal: 'p-3',
        large: 'p-{4px}',
      }[this.size];
    },
    svgClasses() {
      return {
        [this.themeClasses.defaultSvgClasses]: !this.selected,
        [this.themeClasses.hoverSvgClasses]: this.hoverable && !this.selected,
        [this.themeClasses.selectedSvgClasses]: this.selected,
      };
    },
    textClasses() {
      return {
        [this.themeClasses.defaultTextClasses]: !this.selected,
        [this.themeClasses.hoverTextClasses]: this.hoverable && !this.selected,
        [this.themeClasses.selectedTextClasses]: this.selected,
      };
    },
    textSizeClasses() {
      return {
        normal: 'text-14 px-xs',
        large: 'text-18 pl-sm pr-xs',
      }[this.size];
    },
  },
};
</script>
